import { render } from "./ModalReceipts.vue?vue&type=template&id=aa5ed09e"
import script from "./ModalReceipts.vue?vue&type=script&lang=js"
export * from "./ModalReceipts.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__